
var _ = require('underscore');

var ajax = require('ajax');
var DateTime = require('DateTime');
var ReservaDatePicker = require('./ReservaDatePicker');

var PeopleView = require('./views/PeopleView');


let mixin = {

    /**
     * Informationen über Paket-Tage von der API laden
     */
    loadItemDays: function() {
        var item = this.get("item");
        var client = this.get("client"); /* Client wird nur für die MiniEngine gebraucht */
        if ( item === null && client === null ) {
            this.daysModel.reset();
            return Promise.resolve(true);
        }

        var query = {};
        if ( item ) query.item = item;
        if ( client ) query.client = client;
        query.lang = window.Tramino.lang; 
        
        return ajax('/api/engine/days/', {params: query}).then(function(result) {
            if ( !result.success ) {
                Raven.captureMessage("loadItemDays failed (test 3)", {
                    extra: {
                        item: item,
                        client: client,
                        result: result,
                    },
                });
                return;
            }

            console.log("[loadItemDays] Got " + result.days.length + " days from API");
            this.daysModel.set({
                days: result.days,
                name: result.name,
            });

            /* Anders als bei der IBE wissen wir an diesem Punkt schon, dass der Kalender steht. */
            if ( !this.datepicker.initialized ) {
                throw new Error("State Error: Calendar is no ready yet");
            }

            if ( result.days.length > 0 ) {
                /*
                var days = _.pluck(result.days, "date");
                if ( days.indexOf(this.formModel.get("from")) === -1 ) {
                    this.datepicker.setFrom(null);
                    this.datepicker.setTo(null);
                    this.formModel.set("select_mode", "none");

                    if ( result.days.length > 0 ) {
                        console.log("Setting first calendar day to", result.days[0].date);
                        this.datepicker.datepicker.datepicker("setDate", result.days[0].date);
                    }
                }*/
                this.datepicker.datepicker.datepicker("refresh");
            }

        }.bind(this)).catch(this.promiseError);
    },

    /**
     * DatePicker initialisieren. Kann auch unabhängig
     * von einer vollen Reserva-Anwendung verwendet werden.
     *
     * Erstes Argument ist ein Dict von jQuery-Objekten:
     * - form: Formular, an das der Datepicker gebunden wird
     * - datepicker_display: Anzeige des gewählten Datums
     * - datepicker_container: Container des jQuery UI Datepicker
     * - datepicker_box: Kompletter Container des Datepickers, inklusive aller anderen Widgets
     *                   wie die controls. Optional, verwendet sonst datepicker_container.
     * - datepicker_unchain: Datepicker lösen und ans Ende vom Body packen
     * - datepicker_fixto: An ein bestimmtes Element fixieren
     * - fixto_direction: An ein bestimmtes Element fixieren
     */
    initializeDatepicker: function(nodes) {

        let defaultstartin = nodes.defaultstartin || this.get("defaultstartin");
        let defaultdays = nodes.defaultdays || this.get("defaultdays") || 7;

        console.log("initializeDatepicker: defaultstartin = ", defaultstartin);
        console.log("initializeDatepicker: defaultdays = ", defaultdays);

        // Datepicker anzeigen
        let datepickerOptions = {
            form: nodes.form,
            container: nodes.datepicker_container,
            isTouchDevice: this.get("isTouchDevice"),

            defaultstartin: defaultstartin,
            defaultdays: defaultdays,
            app: this,
            model: this.formModel,
            daysmodel: this.daysModel,
        };
        if ( nodes.numberOfMonths ) {
            datepickerOptions.numberOfMonths = nodes.numberOfMonths;
        }

        this.datepicker = new ReservaDatePicker(datepickerOptions);
        this.datepicker.init();

        this.datepickerButton = nodes.datepicker_display;

        this.on('change:isTouchDevice', e => {
            this.datepicker.isTouchDevice = e.attributes.isTouchDevice;
        });

        if ( nodes.datepicker_fixto ) {
            /* Erstmal irgendwo hin packen dass die Länge ermittelt werden kann */
            nodes.fixto_direction = nodes.fixto_direction || 'bottom';
            nodes.fixto_origin = nodes.fixto_origin || 'left';

            this.datepicker.container.css({
                position: 'fixed',
                top: -10000,
                left: -1000,
                "z-index": $('#menu').css('z-index') + 1,
            });
        }

        /* Unchain funktioniert nur mit der Fixierung */
        if ( nodes.datepicker_unchain ) {
            let unchain_target = $('#page');
            if ( unchain_target.length === 0 ) {
                console.warn("#page is not defined, using body for datepicker unchain");
                unchain_target = $('body');
            }
            this.datepicker.container.detach().appendTo(unchain_target);
        }

        this.formModel.on('change:from change:to change:nights change:select_mode', this.updateDatePickerDisplay);
        this.updateDatePickerDisplay();

        var calendarWidth = this.datepicker.container.outerWidth(true);

        this.datepickerButton.on('click', function(e) {
            e.preventDefault();

            if ( this.get("autoHideWidgets") ) {
                this.hidePeopleSelect();
            }

            if ( this.datepicker.isOpen ) {
                this.hideDatepicker();
                return;
            }

            /* In manchen Templates muss der DatePicker auf der Seite fixiert werden, da er sonst
               von zu kleinen Responsive-Boxen abgeschnitten wird. Was wir doof finden. */
            if ( nodes.datepicker_fixto ) {
                var offset = nodes.datepicker_fixto.offset();
                var height = nodes.datepicker_fixto.outerHeight(true);
                var width = nodes.datepicker_fixto.outerWidth();
                var top;

                if ( nodes.fixto_direction === "top" ) {
                    top = offset.top - this.datepicker.container.outerHeight(true);
                }
                if ( nodes.fixto_direction === "bottom" ) {
                    top = offset.top + height;
                }

                if ( nodes.fixto_origin === "left" ) {
                    /* Verhindern, dass der DatePicker zu weit rechts rutscht */
                    var maxLeft = $(window).width() - calendarWidth - 20;
                    if ( offset.left > maxLeft ) {
                        offset.left = maxLeft;
                    }
                    /* Verhindern, dass der DatePicker zu weit links rutscht */
                    if ( offset.left < 20 ) {
                        offset.left = 20;
                    }
                } else {
                    /* Rechter Rand des Datepickers muss am rechten Rand vom Objekt sein */
                    offset.left = ( offset.left + width ) - this.datepicker.container.outerWidth() + 1;
                }

                console.log("Datepicker Fixto", top, offset.left);

                /* Und nun an die richtige Stelle packen */
                this.datepicker.container.css({
                    position: 'absolute',
                    top: top,
                    left: offset.left,
                });
            }

            this.showDatepicker();
        }.bind(this));

        this.datepicker_initialized = true;
    },

    /**
     * DatePicker einblenden und aktivieren
     */
    showDatepicker: function() {
        this.datepicker.container.show();
        this.datepicker.opened();
        this.datepickerButton.addClass('on');
        this.updateDatePickerDisplay();
        this.trigger("show:datepicker", this);

        $('body').addClass('datepicker-open');
    },

    /**
     * DatePicker ausblenden und aufräumen
     */
    hideDatepicker: function() {
        this.datepicker.container.hide();
        this.datepicker.closed();
        if ( this.datepickerButton && this.datepickerButton.length ) this.datepickerButton.removeClass('on');
        this.updateDatePickerDisplay();

        $('body').removeClass('datepicker-open');
    },

    /**
     * Datepicker-Anzeige aktualisieren
     */
    updateDatePickerDisplay: function() {
        if ( this.datepicker.isOpen ) {
            console.log("updateDatePickerDisplay: Not updating as datepicker is open");
            return;
        }

        var text;
        var from = this.formModel.get("from");
        var to = this.formModel.get("to");
        var nights = this.formModel.get("nights");
        var select_mode = this.formModel.get("select_mode");

        if ( select_mode === "none" ) {
            text = __("dd_selected_none");
            if ( window.Tramino.client == 107 ) {
                text = __("dd_select_date_short");
            }
        } else {
            if ( !from && !to ) {
                text = __("dd_select_date");
            } else {
                text = DateTime.textPeriod(from, to, nights, select_mode);
            }
        }

        this.datepickerButton.text(text);
    },

    /**
     * People initialisieren. Kann auch unabhängig
     * von einer vollen Reserva-Anwendung verwendet werden.
     *
     * Erstes Argument ist ein Dict von jQuery-Objekten:
     * - form: Formular, an das der Selector gebunden wird (optional)
     * - people_display: Anzeige der gewählten Personen
     * - people_container: Container der Auswahlfelder
     * - people_fixto: An einem DOM-Element ausrichten
     */
    initializePeopleSelect: function(nodes) {

        // Personen-Auswahl
        this.peopleView = new PeopleView({
            model: this.formModel,
            el: nodes.people_container,
        });
        this.peopleView.render();

        // Personen-Button
        this.peopleButton = nodes.people_display;

        var peopleSelectorWidth = this.peopleView.$el.outerWidth(true);

        this.peopleButton.on('click', function(e) {
            e.preventDefault();
            
            if ( this.get("autoHideWidgets") ) {
                this.hideDatepicker();
            }

            /* In manchen Templates muss der PeopleSelect auf der Seite fixiert werden, da er sonst
               von zu kleinen Responsive-Boxen abgeschnitten wird. Was wir doof finden. */
            if ( nodes.people_fixto ) {
                var offset = nodes.people_fixto.offset();
                var height = nodes.people_fixto.outerHeight(true);

                /* Verhindern, dass der PeopleSelect zu weit rechts rutscht */
                var maxLeft = $(window).width() - peopleSelectorWidth - 20;
                if ( offset.left > maxLeft ) {
                    offset.left = maxLeft;
                }
                /* Verhindern, dass der PeopleSelect zu weit links rutscht */
                if ( offset.left < 20 ) {
                    offset.left = 20;
                }

                /* Und nun an die richtige Stelle packen */
                this.peopleView.$el.css({
                    position: 'absolute',
                    top: offset.top + height,
                    left: offset.left,
                });

                /* Unchain funktioniert nur mit der Fixierung */
                if ( nodes.people_unchain ) {
                    let unchain_target = $('#page');
                    if ( unchain_target.length === 0 ) {
                        console.warn("#page is not defined, using body for peopleselect unchain");
                        unchain_target = $('body');
                    }
                    this.peopleView.$el.detach().appendTo(unchain_target);
                }
            }

            if ( this.peopleButton.hasClass('on') ) {
                this.hidePeopleSelect();
            } else {
                this.showPeopleSelect();
            }
        }.bind(this));

        if ( nodes.form ) {
            this.formModel.bindToForm(nodes.form);
        }

        /*
        this.formModel.on(this.formModel.peopleFields.map(f => `change:${f}`).join(" "), e => {
            this.updatePeopleDisplay()
        })
        */

        this.updatePeopleDisplay();
        this.peopleselect_initialized = true;
    },

    /**
     * Personen-Auswahl ausblenden
     */
    showPeopleSelect: function() {
        if ( !this.peopleView ) return;

        /* Thomas asked for it. */
        if ( this.formModel.get("rooms") === 0 ) {
            this.formModel.set("rooms", 1);
        }

        this.peopleView.$el.show();
        this.peopleButton.addClass('on');
        this.trigger("show:peopleselect", this);

        $('body').addClass('peopleselect-open');
    },

    /**
     * Personen-Auswahl ausblenden
     */
    hidePeopleSelect: function() {
        if ( !this.peopleView ) return;
        this.updatePeopleDisplay();
        this.peopleView.$el.hide();
        if ( this.peopleButton && this.peopleButton.length ) this.peopleButton.removeClass('on');

        $('body').removeClass('peopleselect-open');
    },

    /**
     * Personen-Auswahl-Feld aktualisieren
     */
    updatePeopleDisplay: function() {
        if ( !this.peopleButton ) return;
        var people = this.formModel.getPeople();
        var text = this.formModel.getPeopleString(people);
        this.peopleButton.text(text);
    },

};

module.exports = function(app) {
	_.extend(app, mixin);
	_.bindAll(app, 
        "hideDatepicker",
        "hidePeopleSelect",
        "loadItemDays",
        "showDatepicker",
        "showPeopleSelect",
        "updateDatePickerDisplay",
        "updatePeopleDisplay",
	);
};



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/WidgetsMixin.js